import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserAuthService {
  activeUser: BehaviorSubject<string> = new BehaviorSubject<string>('');
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly httpClient: HttpClient,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {}

  checkLoginStatus(): Observable<InteractionStatus | null> {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    );
  }
  getProfileDetails(): Observable<any> {
    return this.httpClient.get('https://graph.microsoft.com/v1.0/me');
  }

  getProfilePhoto(): Observable<Blob> {
    return this.httpClient
      .get('https://graph.microsoft.com/v1.0/me/photo/$value', {
        responseType: 'blob',
        headers: new HttpHeaders({ 'Content-Type': 'image/jpeg' }),
      })
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
